import React from 'react'

import { Portlet, Row, Col, Button } from '_zari/core'

import { ZariContext } from '_zari/context'

import { ZrSwal } from 'utils'

import * as JobService from 'services/job.service'

const ObtenerStocksPasadosxSede = () => {
  const __zariContext = React.useContext(ZariContext)

  const [iniciando, setIniciando] = React.useState(false)

  const clickObtener = React.useCallback(() => {
    setIniciando(true)
    ZrSwal.showAlert({
      tipo: 'warning',
      mensaje: '¿Deseas eliminar los stocks de este año?',
      showCerrar: true,
      onSuccess: () => {
        JobService.iniciarJob('COPIAR_STOCK_PASADO')
          .then(() => {
            __zariContext.snack('info', 'Copiar stock pasado iniciado. Se notificará cuando termine.')
          })
          .catch(({ data: { error } }) => __zariContext.snack('error', error))
          .finally(() => setIniciando(false))
      },
      onClose: () => {
        setIniciando(false)
      }
    })
  }, [__zariContext])

  return (
    <Portlet>
      <Portlet.Header title='Copiar Stock Pasado' />
      <Portlet.Body>
        <Row>
          <Col md={12} className='text-right'>
            <Button disabled={iniciando} onClick={clickObtener}>
              Copiar
            </Button>
          </Col>
        </Row>
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(ObtenerStocksPasadosxSede)
